module.exports = __webpack_public_path__ + "media/images/common/menu_btn2-e60e1e40af2039d1647c6266ffd0d7e0.png";